export default {
  "content": "<path d=\"M18.223 16.444a1.778 1.778 0 11-.002 3.557 1.778 1.778 0 01.002-3.557zM12.442 16.75a1.558 1.558 0 010 3.116H5.558a1.558 1.558 0 010-3.116h6.884zM5.777 10.223a1.778 1.778 0 11.001 3.555 1.778 1.778 0 010-3.555zM12 10.223a1.777 1.777 0 110 3.554 1.777 1.777 0 010-3.554zM18.223 10.223a1.777 1.777 0 110 3.554 1.777 1.777 0 010-3.554zM5.777 4a1.778 1.778 0 110 3.556 1.778 1.778 0 010-3.556zM12 4a1.777 1.777 0 110 3.555A1.777 1.777 0 0112 4zM18.223 4a1.778 1.778 0 11-.001 3.555 1.778 1.778 0 010-3.555z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};